import { Buffer } from 'buffer';

/**
 * @module Utils/Encode
 * @description This file contains encode/decode functions 
 * 
 */


/**
 * @function
 * @description The function encodes data to base64 format using the Buffer module in JavaScript.
 * @param data - The data parameter is the input string that needs to be encoded in base64 format.
 * @returns The function `encodeBase64` takes in a parameter `data` and returns the base64 encoding of
 * that data using the `Buffer.from()` method and the `toString()` method with the argument `'base64'`.
 */
export const encodeBase64 = (data) => {
        return Buffer.from(data).toString('base64');
}

/**
 * @function
 * @description The function decodes a base64 encoded string into an ASCII string using the Buffer module in
 * JavaScript.
 * @param data - The data parameter is a string that represents the base64 encoded data that needs to
 * be decoded.
 * @returns The function `decodeBase64` takes a string `data` encoded in base64 and returns the decoded
 * string in ASCII format.
 */
export const decodeBase64 = (data) => {
    return Buffer.from(data, 'base64').toString('ascii');
}